import { useEffect, useState } from 'react';

export const useGoogleSheetData = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // 두 시트의 데이터를 모두 가져오기
    const fetchSheetData = async () => {
      try {
        const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
        const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
    
        // 1. Region Info 시트 데이터 가져오기
        const regionResponse = await fetch(
          `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/RegionInfo!A2:E1000?key=${API_KEY}`
        );
        const regionData = await regionResponse.json();

        // 2. Store Data 시트 데이터 가져오기
        const storeResponse = await fetch(
          `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/StoreData!A2:C1000?key=${API_KEY}`
        );
        const storeData = await storeResponse.json();

        // 3. 데이터 변환 및 조합
        const transformedData = transformData(regionData.values, storeData.values);
        setData(transformedData);
        setIsLoading(false);
        

      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };

    fetchSheetData();
  }, []);


  // transformData 함수 추가
  const transformData = (regionData, storeData) => {
    return regionData.map(region => {
      const [boulId, regionCode, title, people, count] = region;
      
      // 해당 지역의 매장 데이터 필터링
      const regionStores = storeData.filter(store => store[0] === regionCode);
      
      // 연도별로 그룹핑
      const storesByYear = {};
      regionStores.forEach(store => {
        const [_, year, storeName] = store;
        if (!storesByYear[year]) {
          storesByYear[year] = [];
        }
        storesByYear[year].push(storeName);
      });

      // table 배열 생성
      const table = Object.entries(storesByYear)
        .map(([year, stores]) => ({
          year: parseInt(year),
          store: stores
        }))
        .sort((a, b) => b.year - a.year); // 연도 내림차순 정렬

      return {
        boulId: parseInt(boulId),
        region: regionCode,
        title,
        people: parseInt(people),
        count: parseInt(count),
        table
      };
    });
  };

  return { data, isLoading, error };
};